module.exports = __webpack_public_path__ + "img/y-207.7668391a.png";